<template>
    <section class="dark">
        <div class="login-form d-none" >
            <div style="padding:3rem">
              <a href="/">
                <object class="logo-svg" type="image/svg+xml" data="/images/logo.svg"></object>
                <p class="logo-titulo text-dark">Parroquia del Espíritu Santo</p>
              </a>
            </div>
            <form @submit.prevent="submitForm" @close="handleError">
                <div class="form-group">
                    <label for="email">E-Mail</label>
                    <input type="email" id="email" class="form-control" v-model.trim="email" />
                </div>
                <div class="form-group pb-2">
                    <label for="password">Contraseña</label>
                    <input type="password" id="password" class="form-control"  v-model.trim="password" />
                </div>
                <p v-if="!formIsValid">Favor de introducir un E-mail y contraseña validos (debe contener al menos 6 caracteres).</p>
                <button @click="login()" class="btn-block btn btn-success w-100">Iniciar Sesión</button>
            </form>
        </div>
    </section>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      formIsValid: true,
      mode: 'login',
      error: null,
    };
  },
  created(){
    this.$auth0.loginWithRedirect();
  },
  methods:{
    login(){
      this.$auth0.loginWithRedirect();
    }
  }
};
</script>
